import { once } from 'lodash'
import { observer } from 'mobx-react'
import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { MagicLoginModel } from '../../../models/request'
import { NotificationType, RouteLink } from '../../../util/constants'
import { stores, useStores } from '../../../util/stores'
import { AuthPageWrapper } from '../components'

export const MagicLoginPage: React.FC = observer(() => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const [search] = useSearchParams()
    const token = search.get('token')
    const { auth, notifications } = useStores()
    const [loading, setLoading] = useState(true)

    const logIn = useCallback(
        once(() => {
            if (!token) {
                stores.reset()
                return navigate(RouteLink.LOG_IN, { replace: true })
            }

            auth.logIn(new MagicLoginModel(token)).subscribe({
                next(response) {
                    if (response.ok) {
                        if (response.data?.awaiting2fa === false) {
                            navigate(RouteLink.DASHBOARD, { replace: true })
                        } else {
                            navigate(RouteLink.TWO_FA, { replace: true })
                        }
                        return
                    }

                    notifications.createNotification(
                        NotificationType.ERROR,
                        t('messages.invalidToken'),
                        5 * 1000 /* 5 seconds */,
                    )
                    stores.reset()
                    navigate(RouteLink.LOG_IN, { replace: true })
                },
                complete() {
                    console.log('completed')
                    setLoading(false)
                },
            })
        }),
        [auth, token, t],
    )

    useEffect(() => {
        console.log('useEffect')
        console.log(token)
        if (token) {
            logIn()
        }
    }, [])

    return token ? (
        <AuthPageWrapper>
            {loading && <span>{t('messages.loggingYouIn')}</span>}
        </AuthPageWrapper>
    ) : null
})

export default MagicLoginPage
